import React from 'react';
import '../../styles/audiobook/RecordingReview.scss';
import useAppTranslation from '../../hooks/useAppTranslation';

const RecordingReview = ({ recordings, sentences, onComplete }) => {
    const { t } = useAppTranslation('components/audiobook/recordingReview');

    console.log('recordings', recordings);
    return (
        <div className="recording-review-page">
            <div className="inner">
                <div className="review-container">
                    <h3>{t('title')}</h3>
                    <p>{t('description')}</p>
                    <div className="detail-accordian">
                        {recordings.map((blob, index) => (
                            <details
                                key={index}
                                className="recording-item"
                            >
                                <summary>
                                    <strong>
                                        {t('sentenceLabel', {
                                            number: index + 1,
                                        })}
                                    </strong>{' '}
                                    —{' '}
                                    {sentences[index]}
                                </summary>
                                {blob instanceof Blob ? (
                                    <audio
                                        controls
                                        src={URL.createObjectURL(blob)}
                                    />
                                ) : (
                                    <p style={{ color: 'red' }}>
                                        {t('missingRecording')}
                                    </p>
                                )}
                            </details>
                        ))}
                    </div>

                    <button
                        className="save-audio-book"
                        onClick={() => onComplete()}
                    >
                        <img
                            src={'/images/utils/mic.svg'}
                            alt={t('actions.complete')}
                        />
                        <span>{t('actions.complete')}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RecordingReview;
